import {Component, OnInit} from "@angular/core";
import {TeTemplateObjectBaseComponent} from "../te-template-object-base.component";
import {NavigationItem} from "../../../../../../../core/shared/dto/navigation/navigation-item";

@Component(
    {
    selector: "te-template-object-side",
    templateUrl: "./te-template-object-side.component.html",
    styleUrls: ["./te-template-object-side.component.scss"],
    standalone: false
}
)

export class TeTemplateObjectSideComponent extends TeTemplateObjectBaseComponent implements OnInit {

    // Merged navigation: only 2 top-level items (Editor + Test & Vorschau)
    // Sub-tabs (Variablen, Artefakte, Basisdaten, Selected Case) live inside the left panel via p-tabs
    navigationItems: NavigationItem[] = [
        { label: 'Editor', action: 'Editor', icon: 'fa-regular fa-pen-to-square', default: true, toggleable: false },
        { label: 'Test & Vorschau', action: 'Testen', icon: 'fa-regular fa-flask-vial', toggleable: false },
    ];

    ngOnInit() {
        super.ngOnInit();
    }

}